import {createSelector} from 'reselect';
import {getListingPage} from './store';

const getIsTypeaheadInputFocused = createSelector(
    [getListingPage],
    (listingPage) => {
        return listingPage.isTypeaheadInputFocused;
    }
);

export {getIsTypeaheadInputFocused};
